import { Link, NavigationPage } from '@/app/components'
import Text from '@/components/Text/Text'
import { useParams, useRouteMatch } from 'react-router-dom'
import { useState } from 'react'
import SurveyObserver, {
  useSurveyResponder,
} from '@/app/components/SurveyObserver'
import { makes } from '@/types/useVehicleMakes'
import { useNavigation } from '@/app/hooks'
import { surveyResponsesCollection } from '@/reducers/surveyResponses'
import { useAppDispatch, useUrlSearchParam } from '@/hooks'
import Button from '@/components/Button/Button'
import { CardAction, CardActions } from '@/components'
import RadioButton from '@/components/forms/RadioButton'

const surveyName = 'BrandApology'
export default function EvApology() {
  const params = useParams<{ make: string }>()
  const { url } = useRouteMatch()
  const navigation = useNavigation()
  const evMakeNames = makes.map((make) => make.name)
  const validMake = evMakeNames.includes(params.make)
  const suggestCharger = useUrlSearchParam('suggestCharger') === 'true'
  if (params?.make && !validMake) {
    navigation.push('/connect-device/vehicle')
  }
  const dispatch = useAppDispatch()
  const { addSurveyInteraction } = useSurveyResponder(surveyName)
  const [notificationPreference, setNotificationPreference] = useState<
    'yes' | 'no' | ''
  >('')

  const handleRadioChange = (value: 'yes' | 'no') => {
    setNotificationPreference(value)
  }

  const handleSubmit = () => {
    if (notificationPreference === '') {
      return
    }

    addSurveyInteraction({
      action: 'click',
      action_data: {
        notify: notificationPreference === 'yes',
        make: params.make,
      },
    })

    dispatch(surveyResponsesCollection.actions.fetch())

    // Navigate back to brand selector with alert param
    navigation.goBackWithParam('showBrandApologyAlert=true')
  }

  return (
    <SurveyObserver observedSurveys={[surveyName]}>
      <NavigationPage
        id="ev-apology-page"
        title={params.make}
        subtitle={`Integrations with ${params.make} vehicles are currently not available.`}
        navigationOptions={['back']}
      >
        <NavigationPage.SingleCardContent>
          <div className="flex flex-col gap-4 mt-1">
            <Text variant="body1">
              Would you like to be notified when {params.make} support becomes
              available?
            </Text>
            <div className="flex flex-col gap-2">
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => handleRadioChange('yes')}
              >
                <RadioButton
                  checked={notificationPreference === 'yes'}
                  onChange={() => handleRadioChange('yes')}
                />
                <span>Yes</span>
              </div>
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => handleRadioChange('no')}
              >
                <RadioButton
                  checked={notificationPreference === 'no'}
                  onChange={() => handleRadioChange('no')}
                />
                <span>No</span>
              </div>
            </div>
            {suggestCharger && (
              <div className="self-center">
                <Link
                  to={'/connect-device/charger/select'}
                  data-testid="connect-charger-link"
                >
                  Connect my charger instead
                </Link>
              </div>
            )}
          </div>
          <div className="flex-1 flex-grow" />
          <CardActions>
            <CardAction type="primary">
              <Button
                id="smartcar-brand-apology-submit-button"
                variant="primary"
                onClick={handleSubmit}
                disabled={notificationPreference === ''}
              >
                Submit
              </Button>
            </CardAction>
          </CardActions>
        </NavigationPage.SingleCardContent>
      </NavigationPage>
    </SurveyObserver>
  )
}
